import { render, staticRenderFns } from "./Widget.html?vue&type=template&id=c5a4463c&scoped=true&external"
import script from "./Widget.ts?vue&type=script&lang=ts&external"
export * from "./Widget.ts?vue&type=script&lang=ts&external"
import style0 from "./Widget.scss?vue&type=style&index=0&id=c5a4463c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a4463c",
  null
  
)

export default component.exports